import { render } from "./IndexInformationFAQ.vue?vue&type=template&id=1118223c"
import script from "./IndexInformationFAQ.vue?vue&type=script&lang=js"
export * from "./IndexInformationFAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__